var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFunfactBgShape(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 733,
    height: 714,
    viewBox: "0 0 733 714",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    clipPath: "url(#clip0_1_251)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1_251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380.5 482C445.393 482 498 429.393 498 364.5C498 299.607 445.393 247 380.5 247C315.607 247 263 299.607 263 364.5C263 429.393 315.607 482 380.5 482Z",
    fill: "#0049F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.5 462C434.348 462 478 418.348 478 364.5C478 310.652 434.348 267 380.5 267C326.652 267 283 310.652 283 364.5C283 418.348 326.652 462 380.5 462Z",
    stroke: "#BAE900",
    strokeWidth: 40
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M471.786 79C471.786 70.1634 464.623 63 455.786 63H285.043C276.206 63 269.043 70.1635 269.043 79V239.174C269.043 248.01 261.879 255.174 253.043 255.174H92.8672C84.0306 255.174 76.8672 262.337 76.8672 271.174V441.917C76.8672 450.754 84.0306 457.917 92.8672 457.917H253.039C261.876 457.917 269.039 465.081 269.039 473.917V632.169C269.039 641.006 276.202 648.169 285.039 648.169H455.783C464.619 648.169 471.783 641.006 471.783 632.169V472.957C471.783 464.12 478.946 456.957 487.783 456.957H646.997C655.834 456.957 662.997 449.793 662.997 440.957V270.213C662.997 261.377 655.834 254.213 646.997 254.213H487.786C478.95 254.213 471.786 247.05 471.786 238.213V79ZM444.254 446.387C453.09 446.387 460.254 439.223 460.254 430.387V281.743C460.254 272.907 453.091 265.743 444.254 265.743H295.611C286.774 265.743 279.611 272.907 279.611 281.743V430.387C279.611 439.223 286.774 446.387 295.611 446.387H444.254Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M276.896 331.709C276.896 322.872 269.732 315.709 260.896 315.709H150.742C141.906 315.709 134.742 322.872 134.742 331.709V434.451C134.742 443.288 127.579 450.451 118.742 450.451H16C7.16344 450.451 0 457.615 0 466.451V576.605C0 585.441 7.16344 592.605 16 592.605H118.742C127.579 592.605 134.742 599.768 134.742 608.605V710C134.742 718.837 141.906 726 150.742 726H260.896C269.732 726 276.896 718.837 276.896 710V607.931C276.896 599.094 284.059 591.931 292.896 591.931H394.966C403.803 591.931 410.966 584.767 410.966 575.931V465.777C410.966 456.941 403.803 449.777 394.966 449.777H292.896C284.059 449.777 276.896 442.614 276.896 433.777V331.709ZM252.812 584.521C261.649 584.521 268.812 577.357 268.812 568.521V473.862C268.812 465.026 261.649 457.862 252.812 457.862H158.154C149.317 457.862 142.153 465.026 142.153 473.862V568.52C142.153 577.357 149.317 584.521 158.153 584.521H252.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M608.396 331.709C608.396 322.872 601.232 315.709 592.396 315.709H482.242C473.406 315.709 466.242 322.872 466.242 331.709V434.451C466.242 443.288 459.079 450.451 450.242 450.451H347.5C338.663 450.451 331.5 457.615 331.5 466.451V576.605C331.5 585.441 338.663 592.605 347.5 592.605H450.242C459.079 592.605 466.242 599.768 466.242 608.605V710C466.242 718.837 473.406 726 482.242 726H592.396C601.232 726 608.396 718.837 608.396 710V608C608.396 599.163 615.559 592 624.396 592H689.25C698.087 592 705.25 584.837 705.25 576V466C705.25 457.163 698.087 450 689.25 450H624.396C615.559 450 608.396 442.837 608.396 434V331.709ZM584.25 584.521C593.087 584.521 600.25 577.357 600.25 568.521V473.862C600.25 465.026 593.087 457.862 584.25 457.862H489.654C480.817 457.862 473.653 465.026 473.653 473.862V568.52C473.653 577.357 480.817 584.521 489.653 584.521H584.25Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1_251",
    x: 28,
    y: 12,
    width: 705,
    height: 705,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 117.5,
    result: "effect1_foregroundBlur_1_251"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_251"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 733,
    height: 714,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunfactBgShape);
export default __webpack_public_path__ + "static/media/funfact-bg-shape.449cc4020060f1fe1add98d0046aa818.svg";
export { ForwardRef as ReactComponent };